<template>
    <div class="container-resizable" >
        <div ref="containerkpis"></div>
        <div class="kpi-container" v-for="(kpi, index) in kpis" :key="index">
            <div class="container-icon">
                <i :class="kpi.icon" v-if="kpi.type === 'icon'"></i>
                <img src="/assets/layout/images/colombia.png" style="margin-top:10px" alt="colombia" v-else />
            </div>
            <div class="container-data">
                <h2 class="title-kpi">{{ $t(kpi.title) }}</h2>
                <div style="align-items: center;display: flex;">
                    <p class="data-kpi" v-if="!visto">0</p>
                    <NumberOdometro :final="kpi.data" :style="style" v-else /><span class="data-kpi" v-if="kpi.append">{{
                        kpi.append }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NumberOdometro from '@/components/number_odometro.vue';
export default {
    name: "Kpis",
    components: {
        NumberOdometro
    },
    data() {
        return {
            visto: false,
            style: {
                "font-size": "40px",
                "margin": "0px",
                "font-weight": "bolder",
                "text-align": "flex-start"
            },
            kpis: [
                {
                    icon: "mdi mdi-hospital-building",
                    title: "messages.surgeriesPerformed",
                    data: 7092,
                    type: "icon"
                },
                {
                    icon: "mdi mdi-doctor",
                    title: "messages.associateSurgeons",
                    data: 58,
                    type: "icon"
                },
                {
                    icon: "colombia.png",
                    title: "messages.colombianPatients",
                    data: 80,
                    append: "%",
                    type: "image"
                },
                {
                    icon: "mdi mdi-earth",
                    title: "messages.internationalPatients",
                    data: 20,
                    append: "%",
                    type: "icon"
                },

            ],
            scrollPosition: 0
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        handleScroll() {
            this.scrollPosition = window.scrollY;
        },
        isElementInViewport() {
            const rect = this.$refs.containerkpis.getBoundingClientRect();
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
        }
    },
    watch: {
        scrollPosition() {
            if (this.isElementInViewport() && !this.visto) {
                this.visto = true;
            }
        }
    }
}
</script>

<style scoped>
.container-resizable {
    justify-content: space-around;
    background-color: #083078;
    padding-top: 20px;
    padding-bottom: 20px;
    align-items: center;
}

.kpi-container {
    color: #ffffff;
    display: flex;
    flex-wrap: wrap;
    padding: 10px;
    width: fit-content;
    align-items: flex-start;
    height: auto;
}

.kpi-container i {
    font-size: 65px !important;
}

.container-data,
.container-icon {
    display: flex;
    flex-direction: column;
    height: 100%;
    align-items: flex-start;
    justify-content: flex-start;
}

.container-icon {
    padding-right: 20px;
    justify-content: center;
}

.title-kpi {
    font-size: 16px;
    margin: 0px;
    max-width: 140px;
    text-align: flex-start;
}

.data-kpi {
    font-size: 40px;
    margin: 0px;
    font-weight: bolder;
    text-align: flex-start;
}

@media (max-width: 1650px) {
    .container-resizable {
        padding: 30px 10px;
    }
}

@media (max-width: 1030px) {
    .kpi-container i {
        font-size: 50px !important;
    }

    .data-kpi {
        font-size: 30px;
    }
}

@media (max-width: 500px) {
    .kpi-container {
        flex-direction: column;
    }
}

.iOdometer {
    font-size: 2em;
    margin: 0;
}
</style>